var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcReset({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.59206 4.23333C8.31706 4.01667 9.11706 3.875 10.0004 3.875C13.9921 3.875 17.2254 7.10833 17.2254 11.1C17.2254 15.0917 13.9921 18.325 10.0004 18.325C6.00872 18.325 2.77539 15.0917 2.77539 11.1C2.77539 9.61667 3.22539 8.23333 3.99206 7.08333",
    stroke: "#004B91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55859 4.43341L8.96693 1.66675",
    stroke: "#004B91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55859 4.43335L9.36693 6.48335",
    stroke: "url(#paint0_linear_6343_19440)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6343_19440",
    x1: 7.92795,
    y1: 4.43335,
    x2: 7.92795,
    y2: 6.48335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99B7D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADB3BC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReset);
export default __webpack_public_path__ + "static/media/ic_reset.13661ab2635f73fef1d0687cd651d915.svg";
export { ForwardRef as ReactComponent };